import React, { useState } from "react";
import { useAuthContext } from "../../../../Context/AuthContext";
import { useSearchParams } from "react-router-dom";
import ImageUploading from "react-images-uploading";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import loginLady from "../../../../Assets/Images/login-lady.png";

const Step4 = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { nextStep, extraInfo, updateExtraInfo ,adminInfo} = useAuthContext();
  console.log(extraInfo);
  const [profileImage, setProfileImage] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const email = searchParams.get("email");
  console.log(email);
  // Handle image change
  const onChange = (imageList) => {
   
    if (imageList.length > 0) {
      setProfileImage(imageList[0].data_url);
      setIsImageUploaded(true);
      updateExtraInfo({ profile_image: imageList[0].data_url });
    }
  };

  // Handle moving to the next step
  const handleNextStep = () => {
    // if (isImageUploaded) {
      nextStep();
      setSearchParams({ step: 5, email: email });
    // }
  };

  return (
    <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[10px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto">
      <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] login-div">
      <div className="px-6 md:px-2 lg:px-[62px] xl:px-[30px] py-[22px] w-full md:w-1/2">
          
            <div className="flex justify-center items-center mt-2">
              <img src={flowChangerLogo} className="w-[120px]" />
            </div>
            <h2 className="mt-5 mb-3 font-medium text-2xl text-center">
              Upload Your Profile Picture
            </h2>
        

          <div className="flex justify-center items-center">
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile Preview"
                className="mb-4 rounded-full w-[80px] h-[80px] object-cover"
              />
            ) : (
              // <div className="flex justify-center items-center bg-gray-200 mb-4 rounded-full w-[80px] h-[80px]">
              //   <h1 className="left-5 font-medium text-black text-3xl">k</h1>
              // </div>
              ""
            )}
          </div>

          {/* Image Upload Button */}
          <ImageUploading
            multiple={false}
            onChange={onChange}
            dataURLKey="data_url"
          >
            {({ onImageUpload, dragProps }) => (
              <div className="flex justify-center items-center">
                {isImageUploaded ? (
                  <button
                    onClick={handleNextStep}
                    className="bg-purple-600 hover:bg-purple-500 px-4 py-3 rounded-full w-[80%] text-white transition duration-300"
                  >
                    Next Step
                  </button>
                ) : (
                  <button
                    onClick={onImageUpload}
                    className="bg-[#8a25b0] hover:bg-[#884a9f] mb-4 px-4 py-[8px] border-[#8a25b1] rounded-full outline-none w-[290px] font-medium text-white transition duration-300"
                    {...dragProps}
                  >
                    Choose Image
                  </button>
                )}
              </div>
            )}
          </ImageUploading>

          <div className="text-center">
            <div className="flex justify-center items-center">
              <button
                onClick={handleNextStep}
                className="text-[#8a25b0] hover:text-[#884a9f]"
              >
                skip the step
              </button>
            </div>
          </div>
        </div>

        <div className="hidden login-right relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-1/2 lg:w-[50%] xl:w-[50%] text-4xl text-center">
          <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
            Upload your image to personalize your account.
            </h2>
            <div className="right-[-48px] bottom-0 absolute">
              <img src={loginLady} alt="loginLady" className="h-[280px]"/>
            </div>
            <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img src={loginSlash} alt="loginSlash" className="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
